import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useNavigate,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./pages/login/login";
import Dashboard from "./pages/Dashboard/dashboard";
import Member from "./pages/Member/member";
import Product from "./pages/Product/product";
import Promotion from "./pages/Promotion/promotion";
import Notification from "./pages/Notification/notification";
import Reward from "./pages/Reward/reward"
import MainLayout from "./components/Layout/MainLayout";
import Account from "./pages/Account/account";
import Setting from "./pages/Setting/setting";
import "./App.css";
import Tire from "./pages/Tire/Tire";
import Contact from "./pages/HelpCenter/Contact/contact";
import Role from "./pages/UserManagement/Role/role";
import Users from "./pages/UserManagement/Users/users";
import PointReport from "./pages/Report/Point/point";
import Add from "./pages/Report/Add/addPoint";
import Withdraw from "./pages/Report/Withdraw/withdrawPoint";
import ReserveReport from "./pages/Report/Reserve/reserveReport";
import MemberReport from "./pages/Report/MemberList/memberList";
import Privacy from "./pages/Privacy/privacy";
import Reserve from "./pages/Reserve/reserve";
import Faq from "./pages/HelpCenter/FAQ/faq";
import MobileSettings from "./pages/AdminSetting/MobileSettings/mobile_settings";
import AdminPanelSettings from "./pages/AdminSetting/AdminPanelSettings/admin_settings";
import Organization from "./pages/Organization/organization";
import Brand from "./pages/Brand/brand";
import Branch from "./pages/Branch/branch";
import api from "./api/api";
import apiUtil from "./api/apiUtil";
import getToken from "./pages/getToken";
import PermissionMessage from "./components/PermissionMessage/PermissionMessage";
import Loading from "./components/Loading/Loading";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("user")
  );
  const brandId = localStorage.getItem("brandId");
  const userData = JSON.parse(localStorage.getItem("user"));
  const [moduleList, setModuleList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const getAdminInfo = () => {
    const param = {
      userId: userData && userData.userId,
      brandId: brandId,
    };

    api.get("Admin/GetAdminInfo", param, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            localStorage.removeItem("orgLevel");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setModuleList(response.data.data.adminModules);
            setIsLoading(false); // ADD THIS
            handleRedirection(response.data.data.adminModules);
          } else {
            alert(response.data.message);
            setIsLoading(false); // ADD THIS
          }
        },
        (error) => {
          console.log(error);
          setIsLoading(false); // ADD THIS
        }
      )
    );
  };

  const handleRedirection = (moduleList) => {
    for (const action of moduleActions) {
      const module = moduleList.find(
        (module) => module.name === action.name && module.accessLevel === 4
      );
      console.log(module);
      if (module) {
        if (action.route) navigate(action.route);
        return;
      }
    }
  };
  const moduleActions = [
    { name: "Dashboard", route: "/dashboard" },
    { name: "Member", route: "/member" },
    { name: "Reward (Panel & Mobile)", route: "/reward" },
    { name: "Reserve (Panel & Mobile)", route: "/reserve" },
    { name: "Menu", route: "/product" },
    { name: "Promotion", route: "/promotion" },
    { name: "Notification", route: "/notification" },
    { name: "Tier Level", route: "/tier" },
    { name: "Report", route: "/report/point" },
    { name: "Roles", route: "/user-management/role" },
    { name: "Users", route: "/user-management/users" },
    { name: "Setting", route: "/settings/admin-panel-settings" },
    { name: "FAQ", route: "/help-center/faq" },
    { name: "Contact Us", route: "/help-center/contact-us" },
  ];

  console.log(moduleList);

  useEffect(() => {
    if (isAuthenticated) {
      getAdminInfo();
    } else {
      setIsLoading(false); // ADD THIS
    }
  }, [isAuthenticated]);

  // SHOW LOADING INSIDE ROUTE
  if (isLoading) {
    return <Loading />;
  }

  // useEffect(() => {
  //   setIsAuthenticated();
  // }, []);

  return (
    <Routes>
      <Route
        index
        exact
        path="/"
        element={
          isAuthenticated ? (
            moduleList.length > 0 ? (
              <Navigate replace to="/dashboard" />
            ) : (
              <Loading />
            )
          ) : (
            <Navigate replace to="/login" />
          )
        }
        className="loginForm"
      ></Route>
      <Route exact path="/login" element={<Login />}></Route>
      <Route
        exact
        path="/dashboard"
        element={
          moduleList.some(
            (module) => module.name === "Dashboard" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Dashboard />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="dashboard" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/member"
        element={
          moduleList.some(
            (module) => module.name === "Member" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Member />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="member" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/reward"
        element={
          moduleList.some(
            (module) =>
              module.name === "Reward (Panel & Mobile)" &&
              module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Reward />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="reward" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/reward/customer"
        element={
          moduleList.some(
            (module) =>
              module.name === "Reward (Panel & Mobile)" &&
              module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Reward />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="reward" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/reserve"
        element={
          moduleList.some(
            (module) =>
              module.name === "Reserve (Panel & Mobile)" &&
              module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Reserve />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="reserve" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/product"
        element={
          moduleList.some(
            (module) => module.name === "Menu" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Product />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="room" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/promotion"
        element={
          moduleList.some(
            (module) => module.name === "Promotion" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Promotion />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="promotion" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/announcement"
        element={
          moduleList.some(
            (module) =>
              module.name === "Notification" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Notification />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="notification" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/tier"
        element={
          moduleList.some(
            (module) => module.name === "Tier Level" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Tire />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="tier" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/profile-settings"
        element={
          <MainLayout>
            <Setting />
          </MainLayout>
        }
      ></Route>
      <Route
        exact
        path="/account"
        element={
          <MainLayout>
            <Account />
          </MainLayout>
        }
      ></Route>
      <Route
        exact
        path="/help-center/contact-us"
        element={
          // <MainLayout>
          //   <Contact />
          // </MainLayout>
          moduleList.some(
            (module) => module.name === "Contact Us" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Contact />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="contact-us" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/help-center/faq"
        element={
          moduleList.some(
            (module) => module.name === "FAQ" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Faq />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="faq" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/report/point"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <PointReport />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/report/add"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Add />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/report/withdraw"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Withdraw />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/report/reserve-report"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <ReserveReport />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/report/member-report"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <MemberReport />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/user-management/role"
        element={
          moduleList.some(
            (module) => module.name === "Roles" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Role />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="roles" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/user-management/users"
        element={
          moduleList.some(
            (module) => module.name === "Users" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Users />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="users" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/organization"
        element={
          moduleList.some(
            (module) =>
              module.name === "Organization" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Organization />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="organization" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/brand"
        element={
          moduleList.some(
            (module) => module.name === "Brand" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Brand />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="brand" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/branch"
        element={
          moduleList.some(
            (module) => module.name === "Branch" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Branch />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="branch" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/privacy-policy"
        element={
          <MainLayout>
            <Privacy />
          </MainLayout>
        }
      ></Route>
      <Route
        exact
        path="/settings/admin-panel-settings"
        element={
          moduleList.some(
            (module) => module.name === "Setting" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <AdminPanelSettings />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="settings" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/settings/mobile-settings"
        element={
          moduleList.some(
            (module) => module.name === "Setting" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <MobileSettings />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="settings" />
              </MainLayout>
            </>
          )
        }
      ></Route>
    </Routes>
  );
}
export default App;
